import { render, staticRenderFns } from "./newspaper.vue?vue&type=template&id=49f9501c&scoped=true&"
import script from "./newspaper.vue?vue&type=script&lang=js&"
export * from "./newspaper.vue?vue&type=script&lang=js&"
import style0 from "./newspaper.vue?vue&type=style&index=0&id=49f9501c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9501c",
  null
  
)

export default component.exports